import { Box } from '@chakra-ui/react'

export default function TimelineDots() {
  return (
    <Box
      display={{ base: 'none', md: 'block' }}
      position="absolute"
      top={0}
      left="35.5px"
      zIndex={0}
      height="100%"
    >
      <svg width="4px" height="100%" overflow="visible">
        <line
          x1={2}
          y1={0}
          x2={2}
          y2="100%"
          stroke="border.emphasized"
          strokeWidth="4"
          strokeDasharray="0 8"
          strokeDashoffset={4}
          strokeLinecap="round"
        />
      </svg>
    </Box>
  )
}
